/* Ferro Coffee — shared scroll-snap carousel component.
   Markup contract:
   <ferro-carousel data-autoplay="5000">
     <div data-ferro-track> ...slides... </div>
     <button data-ferro-prev></button>
     <button data-ferro-next></button>
     <div data-ferro-dots></div>   (optional)
   </ferro-carousel>
*/
if (!customElements.get('ferro-carousel')) {
  class FerroCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ferro-track]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-ferro-prev]');
      this.nextBtn = this.querySelector('[data-ferro-next]');
      this.dotsWrap = this.querySelector('[data-ferro-dots]');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));
      if (this.dotsWrap) this.buildDots();

      this.track.addEventListener(
        'scroll',
        () => {
          clearTimeout(this._syncTimer);
          this._syncTimer = setTimeout(() => this.sync(), 80);
        },
        { passive: true }
      );

      const delay = parseInt(this.dataset.autoplay || '0', 10);
      if (delay > 0 && this.slides().length > 1) {
        this._paused = false;
        this._timer = setInterval(() => {
          if (!this._paused && this.isConnected) this.page(1, true);
        }, delay);
        this.addEventListener('pointerenter', () => (this._paused = true));
        this.addEventListener('pointerleave', () => (this._paused = false));
        document.addEventListener('visibilitychange', () => {
          this._paused = document.hidden;
        });
      }
      this.sync();
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    slides() {
      return Array.from(this.track.children);
    }

    page(dir, loop) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      let x = t.scrollLeft + dir * t.clientWidth;
      if (loop && dir > 0 && t.scrollLeft >= max - 4) x = 0;
      t.scrollTo({ left: Math.max(0, Math.min(x, max)), behavior: 'smooth' });
    }

    goTo(i) {
      const s = this.slides()[i];
      if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    activeIndex() {
      const s = this.slides();
      const x = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      s.forEach((el, i) => {
        const center = el.offsetLeft - this.track.offsetLeft + el.offsetWidth / 2;
        const d = Math.abs(center - x);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    buildDots() {
      this.dotsWrap.innerHTML = '';
      this.slides().forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(b);
      });
    }

    sync() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prevBtn) this.prevBtn.toggleAttribute('data-disabled', t.scrollLeft <= 4);
      if (this.nextBtn) this.nextBtn.toggleAttribute('data-disabled', t.scrollLeft >= max - 4);
      if (this.dotsWrap) {
        const active = this.activeIndex();
        Array.from(this.dotsWrap.children).forEach((d, i) =>
          d.toggleAttribute('data-active', i === active)
        );
      }
    }
  }
  customElements.define('ferro-carousel', FerroCarousel);
}
